interface HeroSectionProps {
  currentSlide: number;
  setCurrentSlide: (index: number) => void;
}

export default function HeroSection({ currentSlide, setCurrentSlide }: HeroSectionProps) {
  const slides = [
    {
      image: 'https://public.readdy.ai/ai/img_res/cb9cd5225cdc4430ffaaa279db894805.jpg',
      title: '부처님께서 《금강경》을 설하신 바로 그 자리',
      subtitle: '인도 스라바스티 기원정사 인근'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Korean%20Buddhist%20monks%20meditating%20in%20traditional%20temple%20hall%2C%20peaceful%20Zen%20meditation%20practice%2C%20warm%20natural%20lighting%20through%20wooden%20windows%2C%20serene%20spiritual%20atmosphere%2C%20traditional%20Korean%20temple%20interior%20with%20wooden%20floors%2C%20photorealistic%20contemplative%20scene&width=1920&height=1080&seq=hero2&orientation=landscape',
      title: '세계 구도자들의 깨달음을 돕는 한국 조사선의 향기',
      subtitle: '1500년 달마-혜능-한국의 조사선 정통을 이어온 수행 '
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Buddhist%20temple%20courtyard%20in%20India%20with%20traditional%20Korean%20elements%2C%20peaceful%20garden%20with%20lotus%20pond%2C%20ancient%20Bodhi%20tree%2C%20warm%20golden%20hour%20lighting%2C%20spiritual%20pilgrimage%20destination%2C%20serene%20sacred%20atmosphere%2C%20photorealistic%20architectural%20photography&width=1920&height=1080&seq=hero3&orientation=landscape',
      title: '참선과 깨달음의 길',
      subtitle: '전통 화두 참선으로 안내하는 수행 도량'
    }
  ];

  return (
    <section className="relative h-screen mt-20 overflow-hidden">
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            currentSlide === index ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <div className="space-y-6 animate-fade-in">
              <h2 
                className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                {slides[currentSlide].title}
              </h2>
              <p 
                className="text-xl sm:text-2xl text-amber-100 font-medium"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                {slides[currentSlide].subtitle}
              </p>
              
              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4 pt-6">
                <a
                  href="#meditation-apply"
                  className="px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  <i className="ri-meditation-line mr-2"></i>
                  명상/수행 신청하기
                </a>
                <a
                  href="#location"
                  className="px-8 py-4 bg-white/90 hover:bg-white text-amber-900 font-semibold rounded-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  <i className="ri-map-pin-line mr-2"></i>
                  선원 위치 / 오시는 길
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              currentSlide === index ? 'bg-amber-500 w-8' : 'bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`슬라이드 ${index + 1}`}
          ></button>
        ))}
      </div>

      {/* Scroll Down Indicator */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
